export var HourFormat;
(function (HourFormat) {
    HourFormat["format12Hour"] = "format12Hour";
    HourFormat["format24Hour"] = "format24Hour";
})(HourFormat || (HourFormat = {}));
//# sourceMappingURL=HourFormat.js.map